import * as React from "react";

function SvgBBiconsPo(props) {
  return (
    <svg viewBox="0 0 200 200" {...props}>
      <path
        d="M181.87 173.33h-8.58a7 7 0 00.13-1.32V74.67a5.51 5.51 0 00-5.21-5.82H118c-2.68 0-5.19 2.34-5.19 5.82V172a7 7 0 00.13 1.32h-4.13V23.21a5 5 0 00-4.9-5.16H31.49a5 5 0 00-4.9 5.16v150.12h-8.46a4.31 4.31 0 000 8.62h163.74a4.31 4.31 0 100-8.62zm-56.31-88.71h35.25a4.22 4.22 0 110 8.43h-35.25a4.22 4.22 0 110-8.43zm0 22.43h35.25a4.21 4.21 0 110 8.42h-35.25a4.21 4.21 0 110-8.42zm0 22.45h35.25a4.22 4.22 0 110 8.43h-35.25a4.22 4.22 0 110-8.43zm0 22.43h35.25a4.21 4.21 0 110 8.42h-35.25a4.21 4.21 0 110-8.42zm-73 20.85v-31.12a2.68 2.68 0 012.58-2.79h25a2.68 2.68 0 012.58 2.79v31.12zM35.54 39.37a4.16 4.16 0 014.16-4.16h56a4.18 4.18 0 014.19 4.16v.11a4.18 4.18 0 01-4.19 4.16h-56a4.16 4.16 0 01-4.16-4.16zm0 29.14a4.16 4.16 0 014.16-4.16h56a4.18 4.18 0 014.19 4.16v.08a4.21 4.21 0 01-4.19 4.19h-56a4.18 4.18 0 01-4.16-4.19zm0 29.12a4.15 4.15 0 014.16-4.16h56a4.18 4.18 0 014.19 4.16v.1a4.18 4.18 0 01-4.19 4.16h-56a4.16 4.16 0 01-4.16-4.16z"
        data-name="Obecn\xE9 ikony"
      />
    </svg>
  );
}

export default SvgBBiconsPo;
